import {formatTime} from "@/libs/helper";

export const NeoSwipeLocation: React.FC<any> = ({data, uid}) => {
  const swipeLocation = data[uid];
  if (!Array.isArray(swipeLocation) || swipeLocation.length === 0) return null;

  return (
    <>
      <div className="flex items-center gap-1">
        {swipeLocation.map((item: any, index: number) => {
          const {swipe, location} = item;

          if (!swipe || !location) return null;
          const time = formatTime(swipe);
          const [lat, lng] = location.split("_");
          const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;

          return (
            <a
              key={index}
              href={mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 underline hover:text-blue-800"
            >
              {time}
              {index !== swipeLocation.length - 1 ? "," : ""}
            </a>
          );
        })}
      </div>
    </>
  );
};
